export function Footer() {
  return (
    <footer className="text-muted py-5 bg-dark">
      <div className="container">
        <p className="float-end mb-1">
          <a href="#">Ir para o topo</a>
          <i className="bi bi-arrow-up-circle"></i>
        </p>
        <p className="mb-1 white">
          Criança & Cuidado {/*&copy; Systems - */} {new Date().getFullYear()}
        </p>
        {/* <p className="mb-0">
            Lorem ipsum dolor sit amet:
            <ul>
              <li>consectetur adipiscing elit</li>
              <li>sed do eiusmod tempor incididunt ut labore</li>
            </ul>
          </p> */}
      </div>
    </footer>
  );
}
